export const magicWordsValidator = /^(?![-<>]{2})(?!.*[-<>]{2})(?!.*[-<>]{2}$)[-#=\w.]*$/;